<template lang="pug">
  b-modal#getRecentDeposit(
  ref="getRecentDeposit"
  :title="$t('ui.combine.get_recent_deposit')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div
        b-form-group(:label="$t('ui.recent_deposit')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th.sticky-position(width="3%")
                      span #
                    th.sticky-position(width="5%")
                      span {{ $t('ui.id') }}
                    th.sticky-position(width="8%")
                      span {{ $t('ui.member_id') }}
                    th.sticky-position(width="5%")
                      span {{ $tc('ui.banks', 1) }}
                    th.sticky-position(width="8%")
                      span {{ $t('ui.bank_acc_no') }}
                    th.sticky-position(width="8%")
                      span {{ $t('ui.bank_acc_holder') }}
                    th.sticky-position(width="8%")
                      span {{ $t('ui.amount') }}
                    th.sticky-position(width="10%")
                      span {{ $t('ui.promo') }}
                    th.sticky-position(width="10%")
                      span {{ $t('ui.bonus_amount') }}
                    th.sticky-position
                      span {{ $t('ui.remark') }}
                    th.sticky-position.text-right(width="10%")
                      span {{ $t('ui.modified_date') }}
                    th.sticky-position.text-right(width="10%")
                      span {{ $t('ui.created_date') }}
                tbody
                  tr(v-if="depositList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in depositList")
                    td
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span(:title="item.member_id") {{ item.member_id }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                    td
                      span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                    td
                      span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.promotion_id") {{ item.promotion_id }}
                    td
                      span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                    td
                      span(:title="item.remark") {{ item.remark }}
                    td.text-right
                      span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      depositList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  methods: {
    getRecentDeposit: function() {
      let url = config.recentDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.member_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.member_id;
      this.getRecentDeposit();
    }
  }
};
</script>
